<template>
  <Head title="Datenschutzerklärung"/>

  <div class="max-w-2xl mx-auto px-4">
    <h1 class="text-2xl font-bold my-4">Ergänzende Datenschutzerklärung für die Anwendung "DGVT-Fuchs – mein Prüfungstrainer"</h1>

    <h2 class="text-xl font-bold mt-6">Zentrale Datenschutzangaben</h2>
    <p class="mt-2">Die zentralen Datenschutzangaben, die für die gesamte Domain- und Anwendungsanbindung gelten, sind abrufbar über <a href="https://www.dgvt-akademie.de" class="link">https://www.dgvt-akademie.de</a> und <a href="https://campus.dgvt.de" class="link">https://campus.dgvt.de</a>.</p>

    <h2 class="text-xl font-bold mt-6">DGVT-Fuchs – mein Prüfungstrainer</h2>
    <p class="mt-2">Die Anwendung DGVT-Fuchs – mein Prüfungstrainer ist eine Anwendung der DGVT-Ausbildungsakademie gGmbH.</p>

    <h2 class="text-xl font-bold mt-6">Verantwortliche Stelle</h2>
    <p class="mt-2">Verantwortliche Stelle für die Erhebung, Verarbeitung und Nutzung Ihrer personenbezogenen Daten im Sinne des Bundesdatenschutzgesetzes ist die DGVT-Ausbildungsakademie gemeinnützige GmbH, Corrensstraße 44/46, 72076 Tübingen (im Folgenden DGVT-Akademie).</p>
    <p class="mt-2">Sofern Sie der Erhebung, Verarbeitung oder Nutzung Ihrer Daten durch die DGVT-Akademie nach Maßgabe dieser Datenschutzbestimmungen insgesamt oder für einzelne Maßnahmen widersprechen wollen, können Sie Ihren Widerspruch per E-Mail oder Brief an folgende Kontaktdaten senden:</p>
    <address class="mt-2">
      DGVT-Ausbildungsakademie gemeinnützige GmbH<br>
      Günter Ruggaber<br>
      Corrensstraße 44/46<br>
      72076 Tübingen<br>
      E-Mail: <a href="mailto:ruggaber@dgvt.de" class="link">ruggaber(at)dgvt(dot)de</a>
    </address>

    <h2 class="text-xl font-bold mt-6">Datenschutz</h2>
    <p class="mt-2">Bei Fragen zum Datenschutz kontaktieren Sie die externe Datenschutzbeauftragte der DGVT e.V.:</p>
    <address class="mt-2">
      Alexandra Klawonn<br>
      E-Mail: <a href="mailto:dsb@dgvt.de" class="link">dsb(at)dgvt(dot)de</a><br>
      Telefon: <a href="tel:+491792497664" class="link">+49 179 2497664</a>
    </address>

    <h2 class="text-xl font-bold mt-6">Rechtsgrundlage für die Verarbeitung personenbezogener Daten</h2>
    <p class="mt-2">Die Anwendung "DGVT-Fuchs" der DGVT-Akademie dient der Vermittlung von Ausbildungsinhalten, insbesondere zur schriftlichen Abschlussprüfung.</p>
    <p class="mt-2">Soweit wir für die Verarbeitungsvorgänge personenbezogener Daten eine Einwilligungserklärung der betroffenen Personen einholen, dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage für die Verarbeitung personenbezogener Daten. Grundlage der Datenverarbeitung bildet auch Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.</p>

    <h2 class="text-xl font-bold mt-6">Umfang der Datenverarbeitung</h2>
    <p class="mt-2">Die Erhebung und Speicherung von personenbezogenen Daten erfolgt in der DGVT-Fuchs-Anwendung im Sinne der Datensparsamkeit. Wir erheben und verwenden personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung und Optimierung der DGVT-Fuchs-Anwendung, des Support-Angebotes und der Nutzung der enthaltenen Funktionen erforderlich ist und eine Rechtsgrundlage uns dies gestattet.</p>
    <p class="mt-2">Mit dem ersten Login auf der Plattform werden folgende personenbezogene Daten in der DGVT-Fuchs-Anwendung gespeichert:</p>
    <ul class="list-disc pl-6 mt-2">
      <li>E-Mail-Adresse</li>
    </ul>
    <p class="mt-2">Optional können Nutzer*innen freiwillig in ihrem Profil den Vor- und Nachnamen sowie ein Profilbild hinterlegen.</p>
    <p class="mt-2">Innerhalb der DGVT-Fuchs-Anwendung werden Aufrufe von Funktionalitäten durch Nutzer*innen in Form sogenannter Ereignisse automatisiert erfasst. Gespeichert werden:</p>
    <ul class="list-disc pl-6 mt-2">
      <li>Art des Ereignisses</li>
      <li>Name des Nutzers, der das Ereignis verursacht hat</li>
      <li>Zeitpunkt</li>
      <li>IP-Adresse des Nutzers, wenn die Anwendung über den Browser bedient wird</li>
      <li>Weitere ereignisbezogene Daten</li>
    </ul>
    <p class="mt-2">Je nach Natur der eingesetzten Aktivität werden unterschiedliche Daten erfasst und können in den meisten Fällen auch der Person, die sie erzeugt hat, zugeordnet werden. Das sind beispielsweise Aufgabenabgaben, Prüfungssimulationen und die aktive Beteiligung an allen weiteren Aktivitäten, die eine Interaktion zwischen den Nutzer*innen und dem System naturbedingt erfordern.</p>

    <h2 class="text-xl font-bold mt-6">Dauer, für die die personenbezogenen Daten gespeichert werden</h2>
    <p class="mt-2">Personenbezogene Daten werden so lange gespeichert, wie der Benutzer*innen-Account der jeweiligen Benutzer*in in der DGVT-Fuchs-Anwendung existiert. Die Daten werden gelöscht, sobald das Benutzer*innenkonto selbst gelöscht wird – sei es auf persönlichen Wunsch der Benutzer*in oder automatisch, wenn die schriftliche Prüfung erfolgreich absolviert wurde oder die beitragsfreie Mitgliedschaft als in der Ausbildung befindlich bei der DGVT gekündigt wurde. Mit dem Löschen des Benutzer*innenkontos werden auch alle personenbezogenen Daten in der DGVT-Fuchs-Anwendung gelöscht.</p>

    <h2 class="text-xl font-bold mt-6">Kontakt</h2>
    <p class="mt-2">Bei technischen oder inhaltlichen Fragen zur Plattform schreiben Sie gerne eine E-Mail an: <a href="mailto:campus@dgvt.de" class="link">campus@dgvt.de</a></p>

    <p class="mt-6">Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Januar 2023.</p>
  </div>
</template>

<script>
import Layout from '../../Shared/Layout.vue'
import {Head} from '@inertiajs/inertia-vue3'

export default {

  name: 'Datenschutz',

  components: {
    Head,
  },

  layout: Layout,
}
</script>

<style scoped>

</style>